<template>
  <section :class="sticky ? 'sticky-header' : ''">
    <v-card flat>
      <v-row no-gutters class="pt-4 justify-center" align="center">
        <v-col cols="11">
          <v-row class="justify-center">
            <v-col cols="2"></v-col>
            <v-col cols="auto">
              <v-card class="pt-2 pb-2 text-center" flat color='transparent'>
                <v-btn v-if="prevMonthEnabled"
                  icon id="previousMonth" width="50px" @click="flickToPrevMonth()" :disabled="this.loading"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card class="pa-0 display-1 font-weight-bold text-center" min-width="22rem" flat color='transparent'>
                <v-btn v-if="this.showLoadTodaysMonth" icon style="margin-right: 5px;"
                  id="loadTodaysMonth" @click="loadTodaysMonth()" :disabled="this.loading">
                  <v-icon>mdi-calendar-star</v-icon>
                </v-btn>
                <span v-else id="todaysMonthButtonPlaceholder" style="display: inline-block; width: 24px; height: 20px;"></span>
                <label id="monthName">{{ this.displayedDate.format('MMMM YYYY') }}{{ rightText }}</label>
                <v-btn icon id="reload" @click="reload()" :disabled="this.loading">
                  <v-icon :class="this.loading ? 'rotate' : ''">mdi-cached</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card class="pt-2 pb-2 text-center" flat color='transparent'>
                <v-btn icon id="nextMonth" width="50px" @click="flickToNextMonth()" :disabled="this.loading">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            <v-col cols="2">
              <div id="rightTemplate">
                <slot name="rightTemplate"></slot>
                <!-- 
                    ----- BEISPIEL -----
                    <template v-slot:rightTemplate>
                      <b>Fat Text</b>
                    </template>
                -->
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="bottomText" no-gutters class="justify-center">
        <v-col cols="auto">
        </v-col>
        <v-col cols="auto">
          <label id="bottomText" class="pa-0 display-1 font-weight-bold text-center">
            {{ bottomText }}
          </label>
        </v-col>
        <v-col cols="auto">
        </v-col>
      </v-row>
      <v-row v-else no-gutters class="justify-center">
        <div id="bottomTemplate">
          <slot name="bottomTemplate"></slot>
          <!-- 
              ----- BEISPIEL -----
              <template v-slot:bottomTemplate>
                <b>Fat Text</b>
              </template>
          -->
        </div>
      </v-row>
    </v-card>

    <v-row v-if="sticky" no-gutters class="justify-center">
      <v-col cols="11">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="js">
import dayjs from '@util/dayjs';

export default {
  name: 'Flicker',
  props: [ 'loading', 'rightText', 'bottomText', 'sticky' ],

  computed: {
    displayedDate: function () {
      return this.$store.state.displayedMonth;
    },

    showLoadTodaysMonth: function() {
      return dayjs().isSame(this.displayedDate, 'month') == false;
    },

    prevMonthEnabled: function () {
      return this.displayedDate.isAfter(dayjs('2020-07-31')) 
        && dayjs(this.$store.getters.staticUserData.user.activeEmployment.from).isBefore(this.displayedDate);
    }
  },

  methods: {
    reload() {
      this.$root.$emit('reloadApp', this);
    },

    flickToPrevMonth() {
      this.$emit('changeRoute', this.displayedDate.subtract(1, 'months'));
    },

    flickToNextMonth() {
      this.$emit('changeRoute', this.displayedDate.add(1, 'months'));
    },

    loadTodaysMonth() {
      this.$emit('changeRoute', dayjs().date(1));
    }
  }
}
</script> 

<style type="scss">
.sticky-header {
  position: sticky;
  top: 48px;
  z-index: 3;
  background-color: white !important; 
}
.rotate {
  animation: rotation 1s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>